import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const tableOption = function (that) {

  const validatePhone = (rule, value, callback) => {
    var reg = new RegExp("^1[3456789]\\d{9}$");
    if (!reg.test(value)) {
      callback(new Error("手机号码格式不正确"));
    } else {
      callback();
    }
  };

  const validateEmails = (rule, value, callback) => {
    // var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$')
    var reg = new RegExp(
      "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
    );
    if (!reg.test(value)) {
      callback(new Error("邮箱格式不正确"));
    } else if (value.indexOf("@") > 18 || value.indexOf("@") < 4) {
      callback(new Error("邮箱前缀为 4 到 18 个字符"));
    } else {
      callback();
    }
  };

  return {
    add: "新增公司信息",
    edit: "修改公司信息",
    page: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "98px",
    dialogWidth: "800px",
    viewDialogWidth: "700",
    emptyText: "暂无公司信息",
    column: [
      {
        label: "公司名称",
        prop: "companyName",
        formslot: true,
        search: true,
        searchPlaceholder: "请输入公司名称",
        span: 12,
      },
      {
        label: "公司类型",
        prop: "companyType",
        type: "select",
        formslot: true,
        search: true,
        searchPlaceholder: "请选择公司类型",
        dicData: [
          {
            label: '优合公司',
            value: '1'
          },
          {
            label: '第三方公司',
            value: '2'
          },
        ],
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "优合公司";
          } else if (Number(value) === 2) {
            return "第三方公司";
          }
          return "";
        },
        span: 12,
      },
      {
        label: "联系电话",
        prop: "companyPhone",
      },
      {
        label: "公司地址",
        prop: "companyAddress",
        overHidden: true,
      },
    ]
  };
};
export default tableOption;
